module.exports = __webpack_public_path__ + "static/img/AIGenerating.af9e06d9.png";